import { render, staticRenderFns } from "./defaultItem.vue?vue&type=template&id=45448c61&scoped=true"
import script from "./defaultItem.vue?vue&type=script&lang=ts"
export * from "./defaultItem.vue?vue&type=script&lang=ts"
import style0 from "./defaultItem.vue?vue&type=style&index=0&id=45448c61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45448c61",
  null
  
)

export default component.exports